import { Download, Eye } from "lucide-react";
import { API } from "@/lib/api";

export const TicketPass = ({ booking }) => {
  const qrUrl = `${API}/tickets/${booking.booking_id}/qr`;
  const pdfUrl = `${API}/tickets/${booking.booking_id}/pdf`;

  return (
    <div className="rounded-2xl border-2 border-[#D4AF37]/60 bg-gradient-to-br from-[#18181E] via-[#121216] to-[#0A0A0C] p-6 shadow-[0_0_30px_rgba(212,175,55,0.15)] sm:p-8"
      data-testid={`ticket-pass-${booking.booking_id}`}>
      <div className="flex flex-col gap-6 md:flex-row md:items-center">
        <div className="flex-1">
          <p className="text-[10px] tracking-[0.3em] text-[#E5C158]">SIRAKH CREATIONS • E-TICKET</p>
          <h3 className="mt-2 font-serif text-2xl font-bold text-white">{booking.event_name}</h3>
          <div className="mt-4 grid grid-cols-2 gap-x-6 gap-y-3 text-sm">
            <Field label="Name" value={booking.first_name} />
            <Field label="Category" value={booking.category_name} />
            <Field label="Quantity" value={booking.quantity} />
            <Field label="Amount" value={`₹${booking.amount}`} />
            <Field label="Date" value={booking.event_date || "-"} />
            <Field label="Time" value={booking.event_time || "-"} />
            <Field label="Venue" value={booking.venue || "-"} />
            <Field label="Status" value={(booking.ticket_status || "valid").toUpperCase()}
              highlight={booking.ticket_status === "used" ? "text-red-400" : "text-green-400"} />
            <Field label="Booking ID" value={booking.booking_id} />
            <Field label="Payment ID" value={booking.payment_id || "-"} />
          </div>
        </div>

        <div className="flex flex-col items-center gap-3 border-t border-dashed border-[#D4AF37]/30 pt-6 md:border-l md:border-t-0 md:pl-6 md:pt-0">
          <div className="rounded-lg bg-white p-2">
            <img src={qrUrl} alt="QR Code" className="h-36 w-36" data-testid="ticket-qr" />
          </div>
          <p className="text-[10px] text-zinc-500">Scan at entry</p>
          <div className="flex w-full flex-col gap-2">
            <a href={pdfUrl} target="_blank" rel="noreferrer" className="btn-gold !py-2.5 text-sm" data-testid={`download-ticket-pdf-${booking.booking_id}`}>
              <Download size={15} /> DOWNLOAD
            </a>
            <a href={qrUrl} target="_blank" rel="noreferrer" className="btn-outline !py-2.5 text-sm" data-testid={`view-ticket-${booking.booking_id}`}>
              <Eye size={15} /> VIEW QR
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

const Field = ({ label, value, highlight }) => (
  <div>
    <p className="text-[10px] uppercase tracking-wider text-zinc-500">{label}</p>
    <p className={`font-medium ${highlight || "text-white"}`}>{value}</p>
  </div>
);
